function lengthPercentageDataToString(data) {
  if (typeof data === "object")
    return `${data.value}${data.unit}`;
  if (typeof data === "number")
    return `${data}px`;
  return data;
}
export {
  lengthPercentageDataToString
};
//# sourceMappingURL=length-percentage.js.map